import { MenuItem } from '@mui/material'
import Grid from '@/global/components/ui/Grid'
import { CategoriaEnum } from '@acme/auth'
import { FormField } from 'global/components/Form'
import { ExternalLinkIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

export function NovoUsuarioForm() {
    const { watch } = useFormContext()
    const categoriaId = watch('categoriaId')

    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <FormField
                    required
                    select
                    name="categoriaId"
                    label="Categoria de acesso"
                >
                    <MenuItem value={CategoriaEnum.Suporte}>Suporte</MenuItem>
                    <MenuItem value={CategoriaEnum.Cliente}>
                        <span className="flex items-center gap-2">
                            <ExternalLinkIcon size={14} /> Cliente
                        </span>
                    </MenuItem>
                    <MenuItem value={CategoriaEnum.Avaliacao}>
                        <span className="flex items-center gap-2">
                            <ExternalLinkIcon size={14} /> Avaliação
                        </span>
                    </MenuItem>
                    <MenuItem value={CategoriaEnum.Representante}>
                        <span className="flex items-center gap-2">
                            <ExternalLinkIcon size={14} /> Representante
                        </span>
                    </MenuItem>
                </FormField>
            </Grid>
            <Grid item xs={12}>
                <FormField name="email" label="Email" required type="email" />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="nome"
                    label="Nome"
                    max={50}
                    autoComplete="off"
                    helperText="Deixe em branco para exibir o nome derivado do cadastro."
                />
            </Grid>
            {categoriaId === CategoriaEnum.Cliente && (
                <Grid item xs={12}>
                    <FormField
                        name="clienteId"
                        label="ID do Cliente"
                        type="number"
                        required
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <FormField
                    name="password"
                    label="Senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme a senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>
        </Grid>
    )
}
